<template>
  <div class="collection-submit">
    <div class="collection-submit-info">
      <h5>提交的文件将会根据以下信息自动重命名，请认真填写！</h5>
      <div class="submit-form">
        <template v-for="rule in name_rules">
          <div class="form-item" v-if="rule[1] && rule[1].name !== 'initial_name'" :key="rule[0]">
            <label class="">{{ rule[1].name === 'full_name' ? '姓名' : rule[1].name }}</label>
            <van-field v-if="rule[1].name === 'full_name'" readonly v-model="rule[1].value"/>
            <van-field v-else placeholder="必填，最多30个字" maxlength="30" v-model="rule[1].value"/>
          </div>
        </template>
      </div>
      <div class="submit-file-list">
        <h4>文件列表</h4>
        <new-file-item v-for="file in fileList" :file="file" :key="file.id" :preview="false"/>
      </div>
    </div>
    <div class="btn-wrap">
      <div class="btn primary-bgcolor" @click="handleSubmit">确认上传</div>
    </div>
  </div>
</template>

<script>
import {i18n} from '@/utils/i18n'
import config from '@/config'
import { Toast } from 'vant'
import {formatDate, approxSize} from '@/utils/common'
import ajax from '@/utils/ajax'
import {COLLECTION_SUBMIT} from '@/config/api'
import NewFileItem from '../components/NewFileItem'
import {normalizeFile} from '@/utils/fileUtils'

export default {
  name: 'CollectionSumbit',
  i18n,
  components: {
    NewFileItem
  },
  props: {
    collectionInfo: {
      type: Object
    },
    uploadedFile: {
      type: Object
    }
  },
  data () {
    return {
      name_rules: new Map(),
      fileList: []
    }
  },
  computed: {},
  watch: {
    uploadedFile (val, oldVal) {
      if (val !== oldVal) {
        this.handeleFileChanged()
      }
    }
  },
  mounted () {
    if (this.getNamerules(this.collectionInfo).size) {
      this.name_rules = [...this.getNamerules(this.collectionInfo)]
    }
    // sendAppData({type: 1}).then((res) => {
    //   console.log('appCallbackFileList:', res)
    // })
  },
  created () {
    console.log('uploadedFile...', this.uploadedFile)
    document.title = '文件命名'
    this.handeleFileChanged()
  },
  methods: {
    handeleFileChanged () {
      this.fileList = this.uploadedFile.data.map(item => {
        return normalizeFile({...item, extension: item.name.indexOf('.') > -1 ? item.name.split('.')[item.name.split('.').length - 1] : ''}, item.id)
      })
      console.log('this.fileList...', this.fileList)
    },
    getSize (size) {
      return approxSize(size)
    },
    createTime (time) {
      return formatDate(time * 1000, '%YY-%MM-%DD')
    },
    getNamerules () {
      if (!this.collectionInfo) {
        return
      }
      const { is_anonymous, collection_info: { name_rules } } = this.collectionInfo
      let nameRules = new Map()
      name_rules.map((item) => {
        if (item === 'full_name' && !is_anonymous) {
          nameRules = nameRules.set(item, { name: item, value: config.user_info.name, disabled: true })
        } else {
          nameRules = nameRules.set(item, { name: item, value: '' })
        }
      })
      // console.log('nameRules...', nameRules, [...nameRules])
      // this.name_rules = nameRules
      return nameRules
    },
    handleSubmit () {
      const { code } = this.collectionInfo
      let arr = []
      this.name_rules.forEach((item) => {
        arr.push(item[1])
      })
      console.log('123456789', this.name_rules, arr)

      const nameVerify = arr.every(nameItem => {
        if (nameItem.name === 'initial_name') return true
        return !!nameItem.value
      })

      if (!nameVerify) {
        Toast('你的信息填写不完整！请完成后再提交')
        return false
      }

      let nameRulesValue = []
      arr.forEach(name => {
        if (name.name !== 'initial_name') {
          nameRulesValue.push(name.value)
        }
      })

      let uploadSuccessFileIds = []
      if (this.fileList.length) {
        this.fileList.forEach(file => {
          if (file.type === 'file') {
            uploadSuccessFileIds.push({
              file_id: file.id,
              file_name: file.name,
              file_pre: nameRulesValue.join('-')
            })
          }
        })
      }

      const data = {
        code: code,
        files: uploadSuccessFileIds,
        file_ids: [],
        user_name: '',
        file_pre: nameRulesValue.join('-'),
        is_copy: this.$props.uploadedFile.isCopy
      }
      console.log('submit...', data, nameRulesValue)
      Toast.loading({
        mask: true,
        message: '提交中...'
      })
      ajax({
        url: COLLECTION_SUBMIT,
        data: data
      }).then(res => {
        Toast.clear()
        if (res.success) {
          this.fileList = []
          this.$router.push({ query: {uploadSuccess: 1} })
        } else {

        }
      })
    }
  }
}
</script>

<style lang="postcss">
@import 'variables';

.collection-submit {
  display: flex;
  flex-direction: column;
  padding: 12px 20px;
  box-sizing: border-box;
  height: 100%;

  & h5 {
    margin-bottom: 4px;
    color: #9BA7BA;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
  }
  & .collection-submit-info {
    flex: 1 1 auto;
  }
  & .submit-form,
  & .submit-file-list {
    background-color: #fff;
    padding: 16px 16px;
    border-radius: 8px;

    & .form-item {
      margin-bottom: 12px;
      & label {
        color: #626F84;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        margin-bottom: 4px;
      }

      & .van-field {
        height: 48px;
        border: 1px solid #D8E0E8;
        border-radius: 4px;
      }
    }
  }

  & .submit-form {
    margin-bottom: 12px;
  }

  & .submit-file-list {
    background-color: #fff;
    margin-bottom: 25px;
    padding-bottom: 4px;
    h4 {
      color: var(--fontBasicColor);
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 12px;
    }

    & .submit-file-item {
      display: flex;
      padding: 12px 0;
      & .thumb-icon {
        width: 30px;
        margin-right: 16px;
      }
      & .file-info {
        & h4 {
          margin-bottom: 2px;
        }
        & .file-size {
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          color: #626F84;
        }
      }
    }
  }

  & .btn-wrap {
    padding: 8px 0;
    display: flex;
    & .btn {
      min-height: 40px;
      height: 40px;
      line-height: 40px;
      color: #fff;
      flex: 1 1 auto;
      text-align: center;
      border-radius: 4px;
      padding: 0;
      background-color: var(--btnPrimaryColor);
    }
  }
}

</style>
